<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)"
                    >{{
                      $route.path.includes("selling") ? "Booker" : "Operator"
                    }}
                    Tariff</a
                  >
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  {{ rentalLabel }} &hyphen; Chauffeur Rate
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <div class="pull-left">
                  <h2>
                    {{ rentalLabel }} &hyphen; Chauffeur Rate
                    <span><i class="ic-price-calculator"></i></span>
                  </h2>
                  <p>Set all rental rate.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>Class</th>
                  <!-- <th class="text-center">Combinations</th> -->
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="detail-row"
                  v-for="(item, index) in items"
                  :key="index"
                >
                  <td>{{ item.masterClassName }}</td>
                  <!-- <td
                    class="text-center"
                    :class="{ 'sts-danger': item.rateCount === 0 }"
                  >
                    {{ item.rateCount === 0 ? "N/A" : item.rateCount }}
                  </td> -->
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <router-link
                        :to="`/${fareCategory}/hourly-chauffeur/${item.masterClassId}?classname=${item.masterClassName}`"
                      >
                        <button
                          v-if="
                            isAllowToCreate ||
                            isAllowToUpdate ||
                            isAllowToDelete
                          "
                          class="btn btn-default"
                          type="button"
                        >
                          <span>Manage</span>
                        </button>
                      </router-link>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div
              class="dataTables_info --blue25"
              style="padding-top: 15px; padding-bottom: 15px"
            >
              <strong>{{ items.length }} Records</strong>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->
    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import hourlyTariffService from "@/services/master/hourlyTariff/hourlyTariffService.js";

export default {
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
  },
  data() {
    return {
      rentalLabel: null,
      allPermissions: [],
      items: [],
      isLoading: false,
      msg: "Please wait",
      userType: "Unspecified",
      fareCategory: null,
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");

    this.rentalLabel = this.$helper.extractSetting(
      publicSettings,
      "RentalLabel",
      "Hourly"
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    this.userType = profile.userType;

    this.fareCategory = this.$route.path.split("/")[1];

    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
    }
  },
  updated() {
    this.$helper.collapseMenu(`${this.fareCategory}-tariff`);
    this.$helper.setNavigationClass(
      `${this.fareCategory}-rental-chauffeur-link-new`
    );
  },
  methods: {
    async getAll() {
      try {
        this.isLoading = true;
        const response = await hourlyTariffService.getMasterClassname(
          this.fareCategory
        );
        this.items = response.data;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/hourlyTariff/HourlyChauffeur.vue